import * as promiseUtils from "@arcgis/core/core/promiseUtils";
import { useStore } from "../../stores/store.ts";

export const setupHighlightHitTest = ({
  mapView,
  highlightLayer,
  highlightLayerView,
}) => {
  if (!highlightLayer || !mapView || !highlightLayerView) {
    return;
  }
  const performHitTest = promiseUtils.debounce(async (e) => {
    const res = (await mapView.hitTest(e.native, {
      include: [highlightLayer],
    })) as any;
    if (res.results.length) {
      const hitGraphic = res.results[0].graphic;
      useStore
        .getState()
        .setHighlightHandle(highlightLayerView.highlight(hitGraphic));
    } else {
      if (useStore.getState().selectedResults.length > 0) {
        const oids = useStore
          .getState()
          .selectedResults.map((r) => r.FEATUREID);
        highlightLayerView
          .queryFeatures({
            where: `OBJECTID IN (${oids.join(",")})`,
          })
          .then((res) => {
            useStore
              .getState()
              .setHighlightHandle(highlightLayerView.highlight(res.features));
          });
      } else {
        useStore.getState().setHighlightHandle(null);
      }
    }
  });

  mapView.on("pointer-move", (e) => {
    performHitTest(e).catch((err) => {
      if (err.name !== "AbortError") {
        console.error(err);
      }
    });
  });
};
